export  const initialData = [
    //19.02.2026
    {
        fullName: 'Abdurazakov Rustam Kayumov',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000018',
        url: 'https://test.tdtu.uz/storage/pages/February2026/xFiAKAC362XmKVi2LBS2.pdf'
    },
    {
        fullName: "Samadov Mirshoxid Miroqil o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000019',
        url: 'https://test.tdtu.uz/storage/pages/February2026/kga7wRtgYuNCramaCLGw.pdf'
    },
    {
        fullName: "Samatov Mirakbar Mirakilovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000020',
        url: 'https://test.tdtu.uz/storage/pages/February2026/FJHrEUrEyfJ2VIXkpOmS.pdf'
    },
    {
        fullName: 'Mustafoyev Azizjon Olimjonovich',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000021',
        url: 'https://test.tdtu.uz/storage/pages/February2026/CQW4P8s5iuW0cbiqabz3.pdf'
    },
    {
        fullName: 'Jabborov Dilshod Muxtorovich',
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000022',
        url: 'https://test.tdtu.uz/storage/pages/February2026/tZoYJlXBlx4P3j2cl0dR.pdf'
    },
    {
        fullName: "Abdullabekova Dilafruz Rustamjon qizi",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000023',
        url: 'https://test.tdtu.uz/storage/pages/February2026/mN8POlc5AYFXFL5D4DCz.pdf'
    },
    {
        fullName: "Shukurullayev Sarvar Anvar o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000024',
        url: 'https://test.tdtu.uz/storage/pages/February2026/XIUGX80AWcCbbpplkdOL.pdf'
    },
    {
        fullName: "Vahabov Azizbek Toxir o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000025',
        url: 'https://test.tdtu.uz/storage/pages/February2026/WyiMsWcCaGD7QjKMvr0n.pdf'
    },
    {
        fullName: "Xaitmuradov Bobir Olimovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000026',
        url: 'https://test.tdtu.uz/storage/pages/February2026/Fsxh0rtikdjbwYDXjrAv.pdf'
    },
    {
        fullName: "Yaqubov Zafarjon Xakimovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000027',
        url: 'https://test.tdtu.uz/storage/pages/February2026/bSeByM8JO12sZIqcc1Co.pdf'
    },
    {
        fullName: "Axmedov Ahmad Maxmudjonovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000028',
        url: 'https://test.tdtu.uz/storage/pages/February2026/SfWP8h9eKfAH4Wdg8yzO.pdf'
    },
    {
        fullName: "Unarov Abdurauf Norbayevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000029',
        url: 'https://test.tdtu.uz/storage/pages/February2026/Bhz11jqz8nA9YmeBPEKM.pdf'
    },
    {
        fullName: "Xolmuminov Shaxboz Ravshan o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000030',
        url: 'https://test.tdtu.uz/storage/pages/February2026/mGnz1ZAmXnF09bfKtbW5.pdf'
    },
    {
        fullName: "Xalilov Sherzodbek Alijonovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000031',
        url: 'https://test.tdtu.uz/storage/pages/February2026/ViSaRsRYMDsbwHU3SSFd.pdf'
    },
    {
        fullName: "Badalova Dildora Abdumalikovna",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000032',
        url: 'https://test.tdtu.uz/storage/pages/February2026/4li6GPNfBdk6SxXg2IXR.pdf'
    },
    //16.04.2026
    {
        fullName: "Nabiyev Uygun Muradaliyevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000052',
        url: 'https://test.tdtu.uz/storage/pages/April2026/T1wVI5GiFgKVNCiGxaJ3.pdf'
    },
    {
        fullName: "Muxtarov Odilxon Arslanovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000053',
        url: 'https://test.tdtu.uz/storage/pages/April2026/UkkbzHJTIOkgQgsTI33M.pdf'
    },
    {
        fullName: "Qozixonov Madixon Tolibxon o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000054',
        url: 'https://test.tdtu.uz/storage/pages/April2026/98JV3U4vopiq2IfRfdka.pdf'
    },
    {
        fullName: "Nimatullayev Zafar Sunatullayevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000055',
        url: 'https://test.tdtu.uz/storage/pages/April2026/gedzzQn5FyFkAuaO6exT.pdf'
    },
    {
        fullName: "Nimatullayev Sarvar Sunatullayevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000056',
        url: 'https://test.tdtu.uz/storage/pages/April2026/AWzr1roOM1BUrUVt72ME.pdf'
    },
    {
        fullName: "Mustafayev Timur Salavaddinovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000057',
        url: 'https://test.tdtu.uz/storage/pages/April2026/RrNe7Ifge8OlUfJUSUUl.pdf'
    },
    {
        fullName: "Yusupov Rafael Rinat o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000058',
        url: 'https://test.tdtu.uz/storage/pages/April2026/ysFZQj1TZl64lCj2vDla.pdf'
    },
    {
        fullName: "Shakirov Alisher Rustamovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000059',
        url: 'https://test.tdtu.uz/storage/pages/April2026/xipS6gpfmO33eef7cXoQ.pdf'
    },
    {
        fullName: "Xamidov Pulat Mamutdjanovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000060',
        url: 'https://test.tdtu.uz/storage/pages/April2026/hOSc7J2OvPXZ3dDkhR0D.pdf'
    },
    {
        fullName: "Sodiqov Jamoliddin Ro zibayevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000061',
        url: 'https://test.tdtu.uz/storage/pages/April2026/Kggo6OqTWeGsA03CoiZC.pdf'
    },
    {
        fullName: "Boxodirov Islomjon Abdulaziz o`g`li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000062',
        url: 'https://test.tdtu.uz/storage/pages/April2026/tc6MMQUTlWbiCskmeXjA.pdf'
    },
    {
        fullName: "Xoliddinova Mashhuraxon Mutalibjon qizi",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000063',
        url: 'https://test.tdtu.uz/storage/pages/April2026/fR4VBwED8SSBALhxWjAR.pdf'
    },
    {
        fullName: "Yakubov Abrar Tulkunovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000064',
        url: 'https://test.tdtu.uz/storage/pages/April2026/w2Ue3HrR7qNEf12IDrs3.pdf'
    },
    {
        fullName: "Norimov Sherali Komilovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000065',
        url: 'https://test.tdtu.uz/storage/pages/April2026/3I8KFQQLSHIRsUKKI64d.pdf'
    },
    {
        fullName: "Allanazarov Doston Jumaboyevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000066',
        url: 'https://test.tdtu.uz/storage/pages/April2026/1UevHHdLYmIyErOGFDT1.pdf'
    },
    {
        fullName: "Jo'rayev Dilshod Maxmudjonovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000067',
        url: 'https://test.tdtu.uz/storage/pages/April2026/xh9QQbNIWB75qU2LLAhw.pdf'
    },
    {
        fullName: "Bozarov Botirjon Axmatjon o'g'li",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000068',
        url: 'https://test.tdtu.uz/storage/pages/April2026/NrPLOwhzlMV0xDLT10Fr.pdf'
    },
    {
        fullName: "Xushvakov Xurshid Xushmatovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000069',
        url: 'https://test.tdtu.uz/storage/pages/April2026/v936MPvtCst0KeRysAuq.pdf'
    },
    {
        fullName: "Madaminov Rustamjon Raxmatjonovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000070',
        url: 'https://test.tdtu.uz/storage/pages/April2026/pDJH7B6iw4aP5HNExKSB.pdf'
    },
    {
        fullName: "Kurbonov Sarvar Xolxojayevich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000071',
        url: 'https://test.tdtu.uz/storage/pages/April2026/EQA6CN8unPx8skbKRDUo.pdf'
    },
    {
        fullName: "Karimov Ali Axtamovich",
        courseName: "Yoqilgi energetika resurslari iste’molchilarida energiya auditi",
        certificateNumber: 'S-000072',
        url: 'https://test.tdtu.uz/storage/pages/April2026/vONQjHqAU47WDOuA8w5h.pdf'
    },
   //05.03.2026
    {
        fullName: "Kurbonov Orifxon Obidovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000033',
        url: 'https://test.tdtu.uz/storage/pages/March2026/2ybDodpw8NQmeq0kVptE.pdf'
    },
    {
        fullName: "Samoylenko Mixaylo Yuriyovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000034',
        url: 'https://test.tdtu.uz/storage/pages/March2026/3rNKsXIjIkXWtgz9FbmI.pdf'
    },
    {
        fullName: "Jalolov Shaxzod Raim o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000035',
        url: 'https://test.tdtu.uz/storage/pages/March2026/Jb2jqjRubZ2rpNVVqjEK.pdf'
    },
    {
        fullName: "Jumamuratov Kunxoja Mirzamurat uli",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000036',
        url: 'https://test.tdtu.uz/storage/pages/March2026/60pf6K4Eb34MR50l0Oer.pdf'
    },
    {
        fullName: "Orazimbetov Baburbek Ramatulla uli",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000037',
        url: 'https://test.tdtu.uz/storage/pages/March2026/CjRtmoDZXa0Wvw4LyyMA.pdf'
    },
    {
        fullName: "Kozlenko Andrey Vladimirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000038',
        url: 'https://test.tdtu.uz/storage/pages/March2026/ExGVozKMogr4TShCAdJt.pdf'
    },
    {
        fullName: "Perova Yelizaveta Andreyevna",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000039',
        url: 'https://test.tdtu.uz/storage/pages/March2026/lSez4fvtnfafCMiBbIpc.pdf'
    },
    {
        fullName: "Prokudina Kristina Aleksandrovna",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000040',
        url: 'https://test.tdtu.uz/storage/pages/March2026/c6leYypf5zqOfJSF4Kzm.pdf'
    },
    {
        fullName: "Otamurodov Sardor Ilxomovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000041',
        url: 'https://test.tdtu.uz/storage/pages/March2026/UoJfqULO3sQBzFZPD9gX.pdf'
    },
    {
        fullName: "Uzoqov Husan Zokirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000042',
        url: 'https://test.tdtu.uz/storage/pages/March2026/VnMCBmHkMV7sbDLtN7Uk.pdf'
    },
    {
        fullName: "Yakubov Abrar Tulkunovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000043',
        url: 'https://test.tdtu.uz/storage/pages/March2026/BlAJb4y0eCuNX9PfL9Ej.pdf'
    },
    {
        fullName: "Norimov Sherali Komilovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000044',
        url: 'https://test.tdtu.uz/storage/pages/March2026/8hBrqN0yi0SP9XIP4qBq.pdf'
    },
    {
        fullName: "Eshdavlatov Utkir Norboboyevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000045',
        url: 'https://test.tdtu.uz/storage/pages/March2026/vh8qTvXA130m1RJcock7.pdf'
    },
    {
        fullName: "Masharipov Ilhomboy Ikrom o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000046',
        url: 'https://test.tdtu.uz/storage/pages/March2026/dISv5dhn46ceDNRHm7al.pdf'
    },
    {
        fullName: "Urinov Abror Botirovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000047',
        url: 'https://test.tdtu.uz/storage/pages/March2026/oEEtElMK69ZLRQrxVmBN.pdf'
    },
    {
        fullName: "Nimatullayev Zafar Sunatullayevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000048',
        url: 'https://test.tdtu.uz/storage/pages/March2026/iUYmFQdJtICSvp0pHYTN.pdf'
    },
    {
        fullName: "Nimatullayev Sarvar Sunatullayevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000049',
        url: 'https://test.tdtu.uz/storage/pages/March2026/PAefQot5LOrSHKyEUxg5.pdf'
    },
    {
        fullName: "Nabiyev Uygun Muradaliyevich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000050',
        url: 'https://test.tdtu.uz/storage/pages/March2026/NH3OPFqlZKguvZ0vzZya.pdf'
    },
    {
        fullName: "Muxtarov Odilxon Arslanovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000051',
        url: 'https://test.tdtu.uz/storage/pages/March2026/Cj3LGthZBlUMd6m2Kmo1.pdf'
    },
    {
        fullName: "Qozixonov Madixon Tolibxon o'g'li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000052',
        url: 'https://test.tdtu.uz/storage/pages/March2026/7IUCE5MbwknxYYY6TDDJ.pdf'
    },
    {
        fullName: "Jumaboyev Humayun Qahramonovich",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000017',
        url: 'https://test.tdtu.uz/storage/pages/March2026/dBuAsUwnqIrYiUJGd46k.pdf'
    },
    {
        fullName: "Murodov Islomjon Ismatulla o`g`li",
        courseName: "Bino-inshootlar uchun energiya auditorlarini tayyorlash",
        certificateNumber: 'B-000016',
        url: 'https://test.tdtu.uz/storage/pages/March2026/JK1WWCJntUlDZUAjpWap.pdf'
    },
];